import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, LockIcon } from '../../components/ui/Icons';

const TradeSignals: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in">
            {/* Breadcrumbs */}
            <nav className="flex items-center space-x-2 text-sm text-slate-500 mb-6">
                <Link to="/grow" className="hover:text-trade-primary transition-colors">Grow</Link>
                <ChevronRightIcon className="w-4 h-4" />
                <span className="text-slate-900 font-medium">Trade Signals</span>
            </nav>

            <div className="mb-8">
                <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Market Signals</h1>
                <p className="text-slate-600 mt-2 text-lg">
                    AI-driven buy and sell signals based on technical and fundamental analysis.
                </p>
            </div>

            <div className="text-center py-24 bg-slate-50 rounded-2xl border border-slate-100">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-indigo-100 mb-6 relative">
                    <svg className="w-10 h-10 text-indigo-600 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <div className="absolute inset-0 bg-indigo-200 rounded-full animate-ping opacity-20"></div>
                </div>
                <h2 className="text-3xl font-bold text-slate-900 mb-3">Signals Coming Soon</h2>
                <p className="text-slate-600 max-w-lg mx-auto text-lg mb-8">
                    We are fine-tuning our AI models to provide you with the most accurate market insights and trading signals.
                </p>
                <div className="inline-flex items-center px-4 py-2 bg-indigo-50 text-indigo-700 rounded-lg text-sm font-medium border border-indigo-100">
                    <LockIcon className="w-4 h-4 mr-2" />
                    Premium Feature
                </div>
            </div>
        </div>
    );
};

export default TradeSignals;
